"use client";

import {
  Field,
  Text,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ReactNode } from "react";
import * as AccordionUI from "@repo/ui/accordion";
import * as Flex from "@repo/ui/flex";
import { TYPOGRAPHY_LABEL3 } from "../../../../../apps/topshop/theme/topshop-2/typography/typography-constants";
import styles from "./accordion.module.css";

export interface AccordionItemProps {
  value: string;
  title: Field<string>;
  children: ReactNode;
}

const AccordionItem = ({
  value,
  title,
  children,
}: AccordionItemProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (!title || !children) {
    if (!isEditing) {
      return <></>;
    }
  }

  return (
    <AccordionUI.Item
      value={value}
      className={clsx(styles.accordionItem, isEditing && styles.editingItem)}
    >
      <AccordionUI.Header asChild>
        <Flex.Container
          align="center"
          justify="space-between"
          gap="xl"
          className={clsx(
            styles.accordionHeading,
            isEditing && styles.editingSpacing,
          )}
          asChild
        >
          <AccordionUI.Trigger onClick={(e) => e.stopPropagation()}>
            <Text
              tag="h2"
              field={title}
              className={clsx(styles.triggerTitle, TYPOGRAPHY_LABEL3)}
            />
            <AccordionUI.TriggerIcon className={styles.triggerIcon} />
          </AccordionUI.Trigger>
        </Flex.Container>
      </AccordionUI.Header>

      <AccordionUI.Content
        className={clsx(
          styles.contentContainer,
          isEditing && styles.editingContent,
        )}
        forceMount={isEditing ? true : undefined}
      >
        {children}
      </AccordionUI.Content>
    </AccordionUI.Item>
  );
};

export default AccordionItem;
